import React, { Component } from "react";

import { StyledSection, StyledRow, StyledColumn } from "../styles/styledComponents/blocks";
import { H3, P, A, AwesomeLoading } from "../styles/styledComponents/elements";
import trackerData from "../data/tracker.json";
import { fromThemeProps } from "../helpers/utilities";

import { renderTable } from "../helpers/awesomeTable";

import { renderTitleSpan } from "../helpers/renderTitleSpan";


export default class ProgressTracker extends Component {

    componentDidMount() {
      renderTable();
    }

    render() {

        return (
            <div>
                {this.renderMain()}
                {this.renderTable()}
            </div>
        )
    }

    //
    // Partials
    //

    renderMain() {
        return (
            <StyledSection background={fromThemeProps("offWhite")}>
                <StyledRow paddingTop={fromThemeProps("headerHeight")}>
                    <StyledColumn background="none" paddingTop="1.5em">
                        {renderTitleSpan(trackerData, "alt")}
                        <br />
                        <H3>{trackerData.subtitle}</H3>
                    </StyledColumn>
                </StyledRow>
            </StyledSection >
        )
    }

    renderTable() {
        return (
            <StyledSection>
                <div style={{ marginTop: "3em", maxWidth: "60em", width: "90%", position: "relative", paddingTop: "20px" }}>
                    <AwesomeLoading data-idf="loading-spinner" />
                    <div data-type="AwesomeTableView" data-viewID="-NqYH6wXir1Ia4I27P6G"></div>
                </div>
                <StyledRow>
                    <StyledColumn>
                        <P>{trackerData.p1}</P>
                        <hr style={{ width: "100%" }} /><br />
                        <P>{trackerData.p2} <span><A href={trackerData.link1Address} target="_blank">{trackerData.link1Text}</A></span></P>
                        <P>{trackerData.p3[0]} <span><A href={trackerData.link2Address} target="_blank">{trackerData.link2Text}</A></span> {trackerData.p3[1]} <span><A href={`mailto:${trackerData.email}`}>{trackerData.email}</A>.</span></P>
                    </StyledColumn>
                </StyledRow>
            </StyledSection>
        )
    }
}



// WEBPACK FOOTER //
// ./src/pages/progress-tracker.js